import { render, staticRenderFns } from "./VibeControlPanel.vue?vue&type=template&id=54fd93ea&lang=pug&"
import script from "./VibeControlPanel.vue?vue&type=script&lang=js&"
export * from "./VibeControlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports